import { Typography } from 'antd'
import { PropsWithChildren } from 'react'

import { FlexCol, FlexRow } from '../../../../StyledComponents'

interface InfoFieldProps {
  label: string
}

const InfoField: React.FC<PropsWithChildren<InfoFieldProps>> = ({ label, children }) => (
  <FlexRow style={{ gap: '1rem', flexWrap: 'nowrap' }}>
    <FlexCol style={{ minWidth: '8rem' }}>
      <Typography style={{ fontWeight: 600, fontSize: '0.875rem' }}>{label}:</Typography>
    </FlexCol>
    <FlexCol>{children}</FlexCol>
  </FlexRow>
)

export default InfoField
